import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService, ImageService } from '@shared/services';

@Component({
  selector: 'signature-box',
  templateUrl: './signature-box.component.html',
  host: { class: 'height-full height-max-360 relative', '[class.display-none]': '!loading && !rendered' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignatureBoxComponent implements OnChanges {
  @Input() itemUrl:  string;
  @Input() base64:   string;
  @Input() signer:   string;
  @Input() loading:  boolean;

  @Output() base64Callback: EventEmitter<string> = new EventEmitter();

  @HostBinding('class') get classes() { return this.imageError ? 'am-flex-center width-150' : 'width-full' + this.loading ? '' : 'b-grey p-xs' }

  imageBase64: string;
  imageError:  boolean;
  rendered:    boolean;
  constructor(
    private imageService:        ImageService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.itemUrl?.currentValue !== changes?.itemUrl?.previousValue ||
        changes?.base64?.currentValue  !== changes?.base64?.previousValue
    ) this.loadImage();
  }

  private loadImage(): void {
    this.rendered    = null;
    this.imageBase64 = null;
    this.imageError  = null;

    if      (this.base64 ) this.imageBase64 = this.base64;
    else if (this.itemUrl) this.imageService.loadImage(this.itemUrl).subscribe(
      res => this.imageBase64 = res,
      err => this.notificationService.alert(err)
    );
  }

  imageLoaded(): void {
    this.rendered = true;
    this.base64Callback.emit();
  }

  loadImageError(): void {
    this.imageError = true;
    this.imageLoaded();
  }

}
